<template>
    <div class="top-product-categories">
        <b-card no-body>
            <b-card-header class="border-0 p-3">
                <b-row align-v="center">
                    <b-col cols="12">
                        <h3 class="mb-0">
                            Top 5 Product Categories
                        </h3>
                    </b-col>
                </b-row>
            </b-card-header>
            <div v-if="tableData.length > 0" class="card-table rounded-bottom">
                <el-table
                :data="tableData"
                style="width: 100%">
                    <el-table-column
                        prop="commission"
                        label="Product Type"
                        min-width="130"
                    >
                        <template slot-scope="scope">
                            <span class="name">{{ scope.row.product_type }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="cases"
                        label="No. of Cases"
                        min-width="90"
                        class-name="text-center"
                    >
                        <template slot-scope="scope">
                            <span class="text-primary">
                                {{ scope.row.cases }}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="total_sales"
                        label="Total Sales (RM)"
                        min-width="100"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.total_sales | moneyFormatter }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="total_actual_rp"
                        label="Total Actual RP (RM)"
                        min-width="140"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.total_actual_rp | moneyFormatter }}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="py-2 px-3">
                    <b-link href="#">View All</b-link>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'
export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data() {
        return {
            tableData: [
                {
                    product_type: 'KOHATA Project',
                    cases: 8,
                    total_sales: 850000.00,
                    total_actual_rp: 390000.00,
                },
                {
                    product_type: 'Personal Loan',
                    cases: 6,
                    total_sales: 300000.00,
                    total_actual_rp: 140000.00,
                },
            ],
        }
    },
}
</script>